<template>
  <div :class="typeClass" class="alert alert-dismissible fade show" role="alert">
        <i class="fa fa-exclamation-circle me-2"></i> {{ notification.message }}
        <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
    </div>
</template>

<script>
export default {
  name: 'Notification-message',
  props: ['notification'],
  computed:{
    typeClass() {
      return `alert-${this.notification.type}`;
    }
  }
}
</script>

